/**
 * <TutorOffersSkeleton> — la forme de « Offres de cours » au premier chargement : le vrai titre,
 * la rangée d'onglets, trois offres. Ni le rappel « Confirme tes créneaux » (une semaine à
 * re-confirmer n'est pas le cas courant) ni de compte d'offres.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"
import { TabsSkeleton } from "../../molecules/Tabs"
import { TutorOfferCardSkeleton } from "../../organisms/TutorOfferCard"

export function TutorOffersSkeleton() {
    return (
        <Stack gap="4">
            <Title size="text-2xl">Offres de cours</Title>
            <TabsSkeleton widths={[72, 52, 124]} />
            <TutorOfferCardSkeleton />
            <TutorOfferCardSkeleton />
            <TutorOfferCardSkeleton />
        </Stack>
    )
}
